<ng-template #adjuntarArchivos>
    <div class="row justify-content-center">
        <div class="col-md-10 bg-white p-2">
            <!-- titulo -->
            <h4>Archivos Adjuntos <small>(Haga doble click sobre el archivo para descargarlo)</small> </h4>
            <!-- grid -->
            <div>
                <div class="col-md-12">
                    <div class="row">
                        <div class="col-md-12">
                            <dx-data-grid 
                                [dataSource]="listaArchivosAdjuntos" 
                                [columnAutoWidth]="true" 
                                [showBorders]="true"
                                (onRowDblClick)="descargarAdjunto($event.data)"
                            >
                                <dxo-paging [pageSize]="10"></dxo-paging>
                                <dxo-pager [visible]="true"  [showPageSizeSelector]="true" [allowedPageSizes]="[5, 10, 20]" [showInfo]="true">
                                </dxo-pager>
                                
                                <dxi-column caption="Documento" dataField="documento" alignment="center"></dxi-column>
                                <dxi-column caption="archivo" dataField="nombreArchivo" alignment="center"></dxi-column>
                    
                            </dx-data-grid>
                        </div>
                    </div>
                </div>
            </div>
            <!-- botones -->
            <div class="row mt-1">
                <div class="col-md-12">
                    <span class="input-group-btn">
                        <input #file type="file" multiple style="display: none" (change)="seleccionarAdjuntos($event)">
                        <button type="button" class="btn btn-info mr-1" (click)="file.click()">Adjuntar</button>
                    </span>
                    <button type="button" class="btn btn-danger" (click)="descartar()">Cerrar</button>
                </div>
            </div>
        </div>
    </div>
</ng-template>
<button class="btn btn-secondary mr-1" type="button" (click)="inicioComponent(adjuntarArchivos)">
    <span >
        Adjuntos
    </span>
</button>